import { Input, Text } from "@ttc3k/trekker";
import { EnumListType } from "gql/generated";
import {
  ArrowRight,
  OpenSelectHandGesture,
  PlusCircle,
  RefreshDouble,
} from "iconoir-react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { WhereaboutsModal } from "shared/components";
import { ButtonCard } from "shared/components/atoms/ButtonCard/ButtonCard";
import { Flex } from "styled-system/jsx";

type StartNewListModalProps = {
  isOpen: boolean;
  onClose: () => void;
  onListTypeSelect: (listType: EnumListType, name: string) => void;
};

const listTypeOptions = [
  {
    icon: RefreshDouble,
    type: EnumListType.Smart,
  },
  {
    icon: OpenSelectHandGesture,
    type: EnumListType.Manual,
  },
];

export const StartNewListModal = ({
  isOpen,
  onClose,
  onListTypeSelect,
}: StartNewListModalProps) => {
  const { t } = useTranslation();
  const defaultListDetails = { name: "", type: "" };
  const [listDetails, setListDetails] = useState(defaultListDetails);

  const handleClose = () => {
    setListDetails(defaultListDetails);
    onClose();
  };

  const handleNextClick = () => {
    onListTypeSelect(listDetails.type as EnumListType, listDetails.name);
    setListDetails(defaultListDetails);
  };

  return (
    <WhereaboutsModal
      isOpen={isOpen}
      onClose={handleClose}
      title={t("customLists:LIST.CREATE_NEW.TITLE")}
      HeaderIcon={PlusCircle}
      cancelButtonProps={{ onClick: handleClose }}
      saveButtonCopy={t("core:NEXT")}
      saveButtonProps={{
        visual: "accent.blue",
        Icon: ArrowRight,
        isIconRightAligned: true,
        disabled: listDetails.name.length < 1 || listDetails.type.length < 1,
        onClick: handleNextClick,
      }}
      size={"md"}
    >
      <Flex flexDir={"column"} gap={"300"}>
        <Input
          label={t("customLists:LIST.CREATE_NEW.NAME_LABEL")}
          onChange={(e) =>
            setListDetails((prev) => ({ ...prev, name: e.target.value }))
          }
        />
        <Flex flexDir={"column"} gap={"200"}>
          <Text color={"text.mid"} visual={"smallMedium"}>
            {t("customLists:LIST.CREATE_NEW.TYPE_LABEL")}
          </Text>
          <Flex gap={"150"}>
            {listTypeOptions.map((op) => {
              const selected = listDetails.type === op.type;
              return (
                <ButtonCard
                  key={op.type}
                  Icon={op.icon}
                  title={t(`customLists:LIST.CREATE_NEW.${op.type}.TITLE`)}
                  description={t(
                    `customLists:LIST.CREATE_NEW.${op.type}.DESCRIPTION`,
                  )}
                  onClick={() =>
                    setListDetails((prev) => ({ ...prev, type: op.type }))
                  }
                  isSelected={selected}
                />
              );
            })}
          </Flex>
        </Flex>
      </Flex>
    </WhereaboutsModal>
  );
};
